// @ts-nocheck
import React from "react";
import { useQuery } from "react-query";
import genRequest from "includes/request";
import documents_treat from "includes/documents_treat";
import PostVideos from "./PostVideos";

export default function AsyncPostVideos({ postId }) {
	const { data } = useQuery(
		["Documents", "DocumentOfPostAndType", postId, 15],
		() =>
			genRequest("documents/post/" + postId + "/type/15")
				.then((resp) => documents_treat(resp, "name")),
		{
			enabled: !!postId,
			retry: 0,
		}
	);

	if (!data?.length) return null;

	return <PostVideos videos={data} />;
}
